import type { ReelSection } from './deriveReelSections';

/**
 * PLAT-11057 — where the playhead says added clips should land (DS1).
 *
 * One rule, three familiar outcomes: **insert after the Section the playhead is
 * in, unless the playhead is at the very start of the reel.** Parked at 0:00
 * the new clips open the reel; parked anywhere inside a Section they follow it,
 * whole — a Section is a passage and is never split to make room; parked at the
 * end they land at the end, which needs no case of its own because the playhead
 * is then inside the last Section.
 *
 * Returns a Section index to insert *before*, so `0` is the front and
 * `sections.length` is the end.
 */
export function reelInsertIndexAtTime(
  sections: readonly ReelSection[],
  time: number,
): number {
  if (sections.length === 0) return 0;
  if (time <= sections[0].startTime) return 0;

  const containing = sections.findIndex(
    section => time >= section.startTime && time < section.endTime,
  );

  // Past the last Section's end — the playhead sits on the final frame or
  // beyond it, and both mean "at the end".
  return containing === -1 ? sections.length : containing + 1;
}
